let installed = false;

const noop = (_?: any): void => { /* intentionally empty */ };

export const installCtaTracking = (): (() => void) => {
  if (installed) {
    return noop;
  }
  installed = true;

  const handler = (e: MouseEvent): void => {
    const t = e.target as HTMLElement | null;

    // Find nearest <a class="cta"> without optional chaining
    let link: HTMLAnchorElement | null = null;
    if (t && typeof (t as any).closest === 'function') {
      link = (t as any).closest('a.cta') as HTMLAnchorElement | null;
    }

    const snoobi: any = (window as any).snoobi;

    if (link && snoobi && typeof snoobi.trackPageView === 'function') {
      const text = ((link.textContent || '')).trim().replace(/\s+/g, '-');
      const label = '/cta-click/' + encodeURIComponent(text);
      try {
        snoobi.trackPageView(label);
      } catch (err) {
        noop(err); // keep block non-empty without logging
      }
    }
  };

  const attach = (): void => {
    if (document && document.body && (document.body as any).addEventListener) {
      (document.body as any).addEventListener('click', handler as any);
    }
  };

  if (document && document.body) {
    attach();
  } else {
    const onReady = (): void => {
      (document as any).removeEventListener('DOMContentLoaded', onReady as any);
      attach();
    };
    (document as any).addEventListener('DOMContentLoaded', onReady as any);
  }

  // Teardown
  return (): void => {
    installed = false;
    try {
      if (document && document.body && (document.body as any).removeEventListener) {
        (document.body as any).removeEventListener('click', handler as any);
      }
    } catch (err) {
      noop(err);
    }
  };
};



// WEBPACK FOOTER //
// ./src/ctaTracking.ts